module.exports = __webpack_public_path__ + "static/media/Solero-JPG-Image-4ct-CREAM-Orange-Image.d1f49e36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/Solero-JPG-Image-4ct-CREAM-Orange-Image.jpg
// module id = 184
// module chunks = 0